/**
 * 广西
 * 商机
 * 右侧编辑区
 * 表单属性
 * 
 */

export default {
    showPosition: 'left', //对齐方式
    lableWidth: '80', //标签宽度
    backColor: '#ffffff', //区域背景颜色
    fontColor: '#333333', //字体颜色
}